<template>
    <div>
        <md-progress-spinner v-if="isLoading"
            md-mode="indeterminate"></md-progress-spinner>

        <md-field v-else
            :class="{'md-invalid': $v.category.name.$dirty && $v.category.name.$invalid}">
            <label>
                {{ this.$t('categories.category-name') }}
            </label>
            <md-input v-model="category.name"
                @input="$v.category.name.$touch()"></md-input>
            <span class="md-error"
                v-show="$v.category.name.$dirty && $v.category.name.$invalid">
                {{ $tc('validations.required-field', 1) }}
            </span>
        </md-field>

        <div class="action-bar">
            <md-button class="md-raised"
                @click="close">
                {{ $t('actions.cancel') }}
            </md-button>
            <md-button class="md-raised md-primary"
                @click="saveCategory"
                :disabled="$v.$invalid">
                {{ $t('actions.confirm') }}
            </md-button>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import categoriesService from '@/components/categories/services/'
import { required } from 'vuelidate/lib/validators'

const loadingKeys = {
    creatingItem: 'creating-item',
    fetchingItem: 'fetching-item'
}

export default {
    name: 'CategoryMaintenance',

    data: () => ({
        category: {
            id: null,
            name: ''
        },

        isViewMode: false,
        isAddMode: false,
        isEditMode: false,

        loadings: []
    }),

    validations: {
        category: {
            name: {
                required
            }
        }
    },

    computed: {
        isLoading() {
            return this.isFetchingCategories || this.isCreatingCategories
        },

        isCreatingCategories() {
            return !!this.loadings.filter(
                loading => loading.key === loadingKeys.creatingItem
            ).length
        },

        isFetchingCategories() {
            return !!this.loadings.filter(
                loading => loading.key === loadingKeys.fetchingItem
            ).length
        }
    },
    methods: {
        async saveCategory() {
            let self = this

            _.fill(this.loadings, loadingKeys.creatingItem)

            let params = {
                category_name: self.category.name
            }
            // eslint-disable-next-line
            let response

            if (this.isAddMode) {
                response = await categoriesService.create(params)
            } else {
                response = await categoriesService.update(self.category.id, params)
            }

            _.pull(this.loadings, loadingKeys.creatingItem)
            this.$router.go(-1)
        },

        async fetchCategory() {
            let self = this

            let id = self.$route.params.id

            _.fill(this.loadings, loadingKeys.fetchingItem)

            let response = await categoriesService.get(id)

            let item = _.cloneDeep(response.data)
            self.category.id = item.category_id
            self.category.name = item.category_name

            _.pull(this.loadings, loadingKeys.fetchingItem)
        },

        close() {
            this.$router.go(-1)
        },

        setMode(mode) {
            switch (mode) {
                case 'view-category':
                    this.isViewMode = true
                    break
                case 'add-category':
                    this.isAddMode = true
                    break
                case 'edit-category':
                    this.isEditMode = true
                    break
            }
        }
    },

    created() {
        this.setMode(this.$route.name)

        if (!this.isAddMode) {
            this.fetchCategory()
        }
    }
}
</script>
